import { render, staticRenderFns } from "./InvoicePaymentMethodForm.vue?vue&type=template&id=1af2b1e1&scoped=true&"
import script from "./InvoicePaymentMethodForm.vue?vue&type=script&lang=ts&"
export * from "./InvoicePaymentMethodForm.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicePaymentMethodForm.vue?vue&type=style&index=0&id=1af2b1e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af2b1e1",
  null
  
)

export default component.exports